import React from "react";

const PrivacyPolicyBg: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto p-6 text-neutral-800 dark:text-neutral-200">
      <h1 className="text-3xl font-bold mb-4">Политика за поверителност</h1>
      <p className="mb-6">В сила от: 28.01.2025</p>

      <p className="mb-4">
        В TryBuy.club ценим Вашата поверителност и сме ангажирани да защитаваме личната Ви
        информация. Настоящата Политика за поверителност обяснява как събираме, използваме,
        разкриваме и пазим Вашите данни, когато използвате нашата платформа. Моля, прочетете
        внимателно, за да разберете нашите принципи и практики относно личните Ви данни и начина, по
        който ги обработваме.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Каква информация събираме</h2>
      <ul className="list-disc list-inside mb-4">
        <li>
          <strong>Лична информация:</strong> Име, имейл адрес, телефон, платежни данни.
        </li>
        <li>
          <strong>Информация за имоти:</strong> Подробности за хотели или имоти, когато създавате
          обява.
        </li>
        <li>
          <strong>Данни за използване:</strong> Разгледани страници, време на престой, модел на
          навигация.
        </li>
        <li>
          <strong>Комуникационни данни:</strong> Записи на съобщения и обратна връзка.
        </li>
        <li>
          <strong>Технически данни:</strong> IP адрес, браузър, операционна система и др.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Как използваме Вашата информация</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Управление на акаунт</li>
        <li>Предоставяне на услуги</li>
        <li>Комуникация и известия</li>
        <li>Маркетинг и реклама</li>
        <li>Подобрение на платформата</li>
        <li>Спазване на закона</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Споделяне на Вашата информация</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Доставчици на услуги</li>
        <li>Бизнес сделки</li>
        <li>Законодателни изисквания</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Сигурност на данните</h2>
      <p className="mb-4">
        Използваме надеждни мерки за защита на Вашите данни, но никой метод не е 100% сигурен.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Вашите права</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Достъп и корекция</li>
        <li>Изтриване на данни</li>
        <li>Отказ от маркетинг</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Бисквитки и технологии за проследяване</h2>
      <p className="mb-4">
        Използваме бисквитки за подобряване на изживяването. Можете да ги управлявате от настройките
        на браузъра.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Връзки към трети страни</h2>
      <p className="mb-4">
        Не носим отговорност за външни сайтове, свързани чрез нашата платформа.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Съхранение на данните</h2>
      <p className="mb-4">
        Съхраняваме данните толкова дълго, колкото е необходимо за посочените цели или по закон.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. Международен трансфер на данни</h2>
      <p className="mb-4">
        Данните Ви може да бъдат прехвърляни в държави с различно ниво на защита.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">10. Актуализации</h2>
      <p className="mb-4">
        Можем да актуализираме политиката. При промени ще Ви уведомим чрез имейл или съобщение в
        платформата.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">11. Контакти</h2>
      <p>
        📧 Email: sales@trybuy.club <br />
        📱 WhatsApp: 📞 +359 885 344 182, 📞 +359 885 368 594
      </p>
    </div>
  );
};

export default PrivacyPolicyBg;
